import { ref, computed } from 'vue'

const messages = {
  de: {
    accountCreationMessage: 'Begrüssungsnachricht (optional)',
    attachFile: 'Datei anhängen',
    attachmentFailed: 'Senden fehlgeschlagen.',
    attachmentTitle: 'Datei senden',
    backToFolder: 'Zurück zum Ordner',
    backToLogin: 'Zurück zum Login',
    cancel: 'Abbrechen',
    changePassword: 'Passwort ändern',
    chatIntegration: 'Chat-Integration',
    chatLogin: 'Chat Login',
    chats: 'Chats',
    city: 'Stadt',
    close: 'Schliessen',
    codeInvalid: 'Code ungültig oder abgelaufen.',
    confirm: 'Bestätigen',
    connecting: 'Verbinde...',
    continueChat: 'Weiter chatten',
    country: 'Land',
    create: 'Chat Empfänger hinzufügen',
    currentPassword: 'Aktuelles Passwort',
    delete: 'Löschen',
    deleteConfirmBody: 'Möchten Sie diese Nachricht wirklich löschen? Dies kann nicht rückgängig gemacht werden.',
    deleteMessage: 'Nachricht löschen',
    domain: 'Domain',
    domainAccount: 'Domain Account',
    dropZoneHint: 'Datei hierher ziehen oder klicken',
    edit: 'Bearbeiten',
    editFailed: 'Bearbeiten fehlgeschlagen.',
    editForbidden: 'Diese Nachricht kann nicht bearbeitet werden.',
    editKeepsAttachment: 'Der angehängte Datei-Link bleibt erhalten.',
    editMessage: 'Nachricht bearbeiten',
    email: 'E-Mail',
    emailCodeBody: 'Wir haben Ihnen einen Anmeldecode per E-Mail gesendet. Bitte geben Sie den 6-stelligen Code ein, um Ihre E-Mail-Adresse zu bestätigen.',
    emailCodeTitle: 'E-Mail-Adresse bestätigen',
    enterCode: 'Code eingeben',
    errorLoginFailed: 'Anmeldung fehlgeschlagen — Benutzername oder Passwort falsch.',
    errorLoginLocked: 'Konto ist gesperrt bis {until}.',
    errorNotLoggedIn: 'Nicht angemeldet.',
    existingAccountHint: 'Zu dieser E-Mail-Adresse gibt es bereits ein TiBTiX Chat-Konto. Bitte melden Sie sich an, damit wir diesen Chat sicher Ihrem bestehenden Konto hinzufügen können.',
    fileTooLarge: 'Datei ist zu gross (max. {max}).',
    files: 'Dateien',
    filter: 'Filter',
    firstName: 'Vorname',
    flags: 'Flags',
    forgotPassword: 'Passwort vergessen...',
    getEmailCode: 'Anmeldecode per E-Mail erhalten',
    hashChat: 'TiBTiX Chat',
    imageUploadFailed: 'Upload fehlgeschlagen.',
    imageUploaded: 'Bild erfolgreich hochgeladen.',
    lastName: 'Nachname',
    later: 'Später',
    liveUpdates: 'Live-Updates',
    loading: 'Laden...',
    login: 'Login',
    loginAndSend: 'Login und Textnachricht schicken',
    loginAsClient: 'Als Kunde einloggen',
    loginFailed: 'Login fehlgeschlagen',
    logout: 'Logout',
    messageTo: 'Nachricht an',
    newChat: 'Neuer Chat',
    newChatExplain: 'Der neue Kunde wird angelegt und erhält per E-Mail die Aufforderung, ein Passwort festzulegen. Sobald er sich angemeldet hat, kann er an diesem Chat teilnehmen.',
    newChatFailed: 'Anlegen des Chats fehlgeschlagen.',
    newChatSuccess: 'Chat wurde angelegt. Der Kunde erhält in Kürze eine E-Mail.',
    newChatTitle: 'Neuen Chat per E-Mail starten',
    newPassword: 'Neues Passwort',
    noConnectionForUpload: 'Kein Chat-Kontakt verfügbar — Upload nicht möglich.',
    number: 'Nummer',
    openExistingChat: 'Vorhandenen Chat öffnen',
    partnerProfile: 'Profil des Kunden',
    password: 'Passwort',
    passwordChangeFailed: 'Passwort-Änderung fehlgeschlagen.',
    passwordChanged: 'Passwort erfolgreich geändert.',
    passwordMismatch: 'Die Passwörter stimmen nicht überein.',
    passwordOfferBody: 'Sie können TiBTiX Chat auch ohne Passwort verwenden und sich mit einem E-Mail-Code anmelden. Ein eigenes Passwort ist nützlich, wenn Sie Dateien hochladen oder sich schneller anmelden möchten.',
    passwordOfferTitle: 'Passwort später festlegen',
    passwordTooShort: 'Das Passwort muss mindestens 8 Zeichen haben.',
    passwordTooShort10: 'Das Passwort muss mindestens 10 Zeichen haben.',
    periodicRefresh: 'Live-Verbindung nicht möglich – aktualisiere periodisch',
    phoneNumber: 'Telefonnummer',
    prefilledMessage: 'Vorgefertigte Nachricht',
    privacyConsent: 'Ich akzeptiere die Datenschutzerklärung und bin einverstanden, dass meine Angaben zur Bearbeitung meiner Anfrage gespeichert werden.',
    profile: 'Profil',
    profileImage: 'Profilbild',
    reconnect: 'Verbinden / Neu laden',
    registerCompany: 'Firma registrieren...',
    removeFile: 'Entfernen',
    repeatNewPassword: 'Neues Passwort wiederholen',
    requestPassword: 'Passwort anfordern',
    resendCode: 'Code erneut senden',
    resendTooSoon: 'Bitte kurz warten, bevor Sie einen neuen Code anfordern.',
    resetPasswordFailed: 'Passwort-Anforderung fehlgeschlagen',
    resetPasswordSent: 'Ein temporäres Passwort wurde an {email} gesendet.',
    resetPasswordTitle: 'Neues temporäres Passwort anfordern',
    save: 'Speichern',
    saveChatBody: 'Wenn Sie Ihre E-Mail-Adresse bestätigen, können Sie diesen Chat später wieder öffnen. Wir legen dafür ein kostenloses Chat-Konto an. Sie können sich danach jederzeit mit einem E-Mail-Code anmelden. Ein Passwort können Sie später festlegen.',
    saveChatTitle: 'Diesen Chat speichern?',
    saveFailed: 'Speichern fehlgeschlagen.',
    saved: 'Gespeichert.',
    selectChat: 'Chat auswählen',
    selectImage: 'Bild auswählen',
    send: 'Senden',
    sendCode: 'Code senden',
    setPassword: 'Passwort festlegen',
    setPasswordAndUpload: 'Passwort festlegen und Upload fortsetzen',
    settings: 'Einstellungen',
    street: 'Strasse',
    tempPasswordNotice: 'Sie haben sich mit einem temporären Passwort angemeldet. Bitte vergeben Sie jetzt ein neues Passwort.',
    terms: 'AGB',
    termsAcceptCheckbox: 'Ich habe die AGB gelesen und stimme zu.',
    termsBody: `1. Anbieter und Geltungsbereich
Diese Nutzungsbedingungen regeln die Nutzung der TiBTiX Chat UI ("Dienst") durch den Nutzer.

2. Nutzung und erlaubte Inhalte
Der Dienst dient ausschliesslich dem Austausch von Nachrichten zwischen registrierten Nutzern. Der Nutzer verpflichtet sich, bei der Nutzung des Dienstes einen respektvollen und sachlichen Umgangston zu wahren. Insbesondere ist es untersagt, Inhalte zu versenden, die beleidigend, diffamierend, bedrohend, belästigend, hetzerisch, diskriminierend, sexuell anstössig oder anderweitig bösartig sind. Ebenfalls untersagt sind rechtswidrige Inhalte, Spam, unerwünschte Werbung, Schadsoftware sowie Inhalte, die Rechte Dritter verletzen (insbesondere Urheber-, Marken- oder Persönlichkeitsrechte). Bei Verstössen behält sich der Anbieter vor, betroffene Nachrichten zu entfernen und das Nutzerkonto vorübergehend oder dauerhaft zu sperren.

3. Konto und Zugangsdaten
Der Nutzer ist verpflichtet, seine Zugangsdaten geheim zu halten. Eine Weitergabe an Dritte ist nicht gestattet.

4. Datenschutz und DSGVO-Konformität
Der Anbieter verarbeitet personenbezogene Daten ausschliesslich im Einklang mit der EU-Datenschutz-Grundverordnung (DSGVO) sowie den ergänzenden nationalen Datenschutzgesetzen. Rechtsgrundlage der Verarbeitung ist Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung) bzw. Art. 6 Abs. 1 lit. f DSGVO (berechtigte Interessen) zum Betrieb und zur Sicherheit des Dienstes. Der Nutzer hat jederzeit das Recht auf Auskunft (Art. 15), Berichtigung (Art. 16), Löschung (Art. 17), Einschränkung der Verarbeitung (Art. 18), Datenübertragbarkeit (Art. 20) sowie Widerspruch (Art. 21 DSGVO). Beschwerden können bei der zuständigen Aufsichtsbehörde eingereicht werden. Einzelheiten zu Verarbeitungszwecken, Speicherfristen und eingesetzten Auftragsverarbeitern enthält die separate Datenschutzerklärung, die der Nutzer mit der Nutzung des Dienstes zur Kenntnis nimmt.

5. Haftung
Der Anbieter haftet unbeschränkt für Schäden aus Vorsatz oder grober Fahrlässigkeit, für die Verletzung von Leben, Körper oder Gesundheit sowie im Rahmen zwingender gesetzlicher Bestimmungen (insbesondere nach dem Produkthaftungsgesetz). Bei einfacher Fahrlässigkeit haftet der Anbieter nur bei Verletzung wesentlicher Vertragspflichten (Kardinalpflichten) und beschränkt auf den vertragstypisch vorhersehbaren Schaden. Die Haftung ist in diesem Fall pro Schadensfall und insgesamt der Höhe nach auf die Vergütung begrenzt, die der Nutzer in den zwölf Monaten vor dem schadensauslösenden Ereignis an den Anbieter gezahlt hat. Eine darüber hinausgehende Haftung ist ausgeschlossen.

6. Verfügbarkeit
Der Anbieter bemüht sich um eine hohe Verfügbarkeit des Dienstes, gewährleistet aber keinen unterbrechungsfreien Betrieb.

7. Änderungen der Bedingungen
Diese Bedingungen können angepasst werden. Bei wesentlichen Änderungen wird der Nutzer beim nächsten Login zur erneuten Zustimmung aufgefordert.

8. Anwendbares Recht
Es gilt das Recht am Sitz des Anbieters, soweit zwingende verbraucherschutzrechtliche Vorschriften nichts anderes vorsehen.

`,
    termsRead: 'AGB lesen...',
    termsRequired: 'Bitte akzeptieren Sie zuerst die AGB.',
    termsTitle: 'Nutzungsbedingungen',
    termsVersionLabel: 'Version',
    unread: 'ungelesen',
    markAllRead: 'Alle gelesen',
    uploadImage: 'Hochladen',
    uploadLaterNotice: 'Der Upload wurde nicht gestartet. Sie können den Chat weiterhin verwenden. Wenn Sie später Dateien hochladen möchten, können Sie jederzeit ein Passwort festlegen.',
    uploadPwBody: 'Um Dateien hochzuladen, benötigen Sie ein vollständiges Chat-Konto mit eigenem Passwort. Legen Sie jetzt ein Passwort fest, um den Upload fortzusetzen.',
    uploadPwTitle: 'Dateien hochladen',
    verifiedBody: 'Dieser Chat wurde gespeichert und ist jetzt mit Ihrem Chat-Konto verbunden. Sie können ihn später mit einem E-Mail-Code wieder öffnen.',
    verifiedTitle: 'Ihre E-Mail-Adresse wurde bestätigt.',
    welcomeMessage: 'Willkommen. Wie können wir Ihnen helfen?',
    guestRateLimited: 'Von diesem Anschluss wurden gerade viele Chats gestartet. Bitte versuchen Sie es in ein paar Minuten erneut.',
    guestUnavailable: 'Der Chat ist im Moment nicht verfügbar. Bitte versuchen Sie es später erneut.',
    writeMessage: 'Nachricht schreiben...',
    zipCode: 'PLZ',
  },
  en: {
    accountCreationMessage: 'Welcome message (optional)',
    attachFile: 'Attach file',
    attachmentFailed: 'Sending failed.',
    attachmentTitle: 'Send file',
    backToFolder: 'Back to folder',
    backToLogin: 'Back to login',
    cancel: 'Cancel',
    changePassword: 'Change password',
    chatIntegration: 'Chat integration',
    chatLogin: 'Chat Login',
    chats: 'Chats',
    city: 'City',
    close: 'Close',
    codeInvalid: 'Code invalid or expired.',
    confirm: 'Confirm',
    connecting: 'Connecting...',
    continueChat: 'Continue chatting',
    country: 'Country',
    create: 'Add chat recipient',
    currentPassword: 'Current password',
    delete: 'Delete',
    deleteConfirmBody: 'Do you really want to delete this message? This cannot be undone.',
    deleteMessage: 'Delete message',
    domain: 'Domain',
    domainAccount: 'Domain Account',
    dropZoneHint: 'Drag a file here or click',
    edit: 'Edit',
    editFailed: 'Editing failed.',
    editForbidden: 'This message cannot be edited.',
    editKeepsAttachment: 'The attached file link is preserved.',
    editMessage: 'Edit message',
    email: 'Email',
    emailCodeBody: 'We have sent you a login code by email. Please enter the 6-digit code to confirm your email address.',
    emailCodeTitle: 'Confirm email address',
    enterCode: 'Enter code',
    errorLoginFailed: 'Login failed — wrong username or password.',
    errorLoginLocked: 'Account is locked until {until}.',
    errorNotLoggedIn: 'Not logged in.',
    existingAccountHint: 'There is already a TiBTiX chat account for this email address. Please sign in so we can securely add this chat to your existing account.',
    fileTooLarge: 'File is too large (max {max}).',
    files: 'Files',
    filter: 'Filter',
    firstName: 'First name',
    flags: 'Flags',
    forgotPassword: 'Forgot password...',
    getEmailCode: 'Get a login code by email',
    hashChat: 'TiBTiX Chat',
    imageUploadFailed: 'Image upload failed.',
    imageUploaded: 'Image uploaded successfully.',
    lastName: 'Last name',
    later: 'Later',
    liveUpdates: 'Live updates',
    loading: 'Loading...',
    login: 'Login',
    loginAndSend: 'Login and send message',
    loginAsClient: 'Login as Client',
    loginFailed: 'Login failed',
    logout: 'Logout',
    messageTo: 'Message to',
    newChat: 'New chat',
    newChatExplain: 'The new client will be created and will receive an email asking them to set a password. Once they have signed in, they can join this chat.',
    newChatFailed: 'Creating the chat failed.',
    newChatSuccess: 'Chat created. The client will receive an email shortly.',
    newChatTitle: 'Start a new chat by email',
    newPassword: 'New password',
    noConnectionForUpload: 'No chat contact available — upload not possible.',
    number: 'Number',
    openExistingChat: 'Open existing chat',
    partnerProfile: 'Customer Profile',
    password: 'Password',
    passwordChangeFailed: 'Password change failed.',
    passwordChanged: 'Password changed successfully.',
    passwordMismatch: 'The passwords do not match.',
    passwordOfferBody: 'You can use TiBTiX Chat without a password and sign in with an email code. Your own password is useful if you want to upload files or sign in faster.',
    passwordOfferTitle: 'Set a password later',
    passwordTooShort: 'Password must be at least 8 characters.',
    passwordTooShort10: 'Password must be at least 10 characters.',
    periodicRefresh: 'Live connection unavailable – refreshing periodically',
    phoneNumber: 'Phone number',
    prefilledMessage: 'Prefilled message',
    privacyConsent: 'I accept the privacy policy and agree that my data is stored to process my request.',
    profile: 'Profile',
    profileImage: 'Profile image',
    reconnect: 'Reconnect / Reload',
    registerCompany: 'Register company...',
    removeFile: 'Remove',
    repeatNewPassword: 'Repeat new password',
    requestPassword: 'Request password',
    resendCode: 'Resend code',
    resendTooSoon: 'Please wait a moment before requesting a new code.',
    resetPasswordFailed: 'Password reset failed',
    resetPasswordSent: 'A temporary password has been sent to {email}.',
    resetPasswordTitle: 'Request new temporary password',
    save: 'Save',
    saveChatBody: 'If you confirm your email address, you can reopen this chat later. We will create a free chat account for you. You can then sign in any time with an email code. You can set a password later.',
    saveChatTitle: 'Save this chat?',
    saveFailed: 'Save failed.',
    saved: 'Saved.',
    selectChat: 'Select a chat',
    selectImage: 'Select image',
    send: 'Send',
    sendCode: 'Send code',
    setPassword: 'Set password',
    setPasswordAndUpload: 'Set password and continue upload',
    settings: 'Settings',
    street: 'Street',
    tempPasswordNotice: 'You logged in with a temporary password. Please set a new password now.',
    terms: 'Terms',
    termsAcceptCheckbox: 'I have read and accept the terms.',
    termsBody: `1. Provider and Scope
These terms govern the use of the TiBTiX Chat UI ("Service") by the user.

2. Use and Acceptable Content
The Service is intended exclusively for exchanging messages between registered users. The user agrees to maintain a respectful and civil tone when using the Service. In particular, sending content that is insulting, defamatory, threatening, harassing, hateful, discriminatory, sexually offensive or otherwise malicious is prohibited. Likewise prohibited are unlawful content, spam, unsolicited advertising, malware and any content that infringes third-party rights (in particular copyrights, trademarks or personality rights). In case of violations, the provider reserves the right to remove affected messages and to suspend or terminate the user account temporarily or permanently.

3. Account and Credentials
The user must keep their credentials confidential. Sharing them with third parties is not permitted.

4. Privacy and GDPR Compliance
The provider processes personal data exclusively in accordance with the EU General Data Protection Regulation (GDPR) and applicable national data protection laws. The legal basis for processing is Art. 6(1)(b) GDPR (performance of a contract) or Art. 6(1)(f) GDPR (legitimate interests) for the operation and security of the Service. The user has the right at any time to access (Art. 15), rectification (Art. 16), erasure (Art. 17), restriction of processing (Art. 18), data portability (Art. 20) and to object (Art. 21 GDPR). Complaints may be lodged with the competent supervisory authority. Details on processing purposes, retention periods and any data processors engaged are set out in the separate privacy notice, which the user acknowledges by using the Service.

5. Liability
The provider's liability is unlimited for damages caused by intent or gross negligence, for injury to life, body or health, and within the scope of mandatory statutory provisions (in particular product liability law). In cases of simple negligence, the provider is liable only for breach of material contractual obligations (cardinal duties) and limited to the contractually typical, foreseeable damage. In such cases, liability per claim and in the aggregate is capped at the fees paid by the user to the provider in the twelve months preceding the event giving rise to the claim. Any further liability is excluded.

6. Availability
The provider strives for high availability of the Service but does not guarantee uninterrupted operation.

7. Changes to the Terms
These terms may be amended. In case of material changes, the user will be asked to re-accept them on the next login.

8. Governing Law
The law at the provider's place of business applies, subject to mandatory consumer protection rules.

`,
    termsRead: 'Read terms...',
    termsRequired: 'Please accept the terms first.',
    termsTitle: 'Terms of Use',
    termsVersionLabel: 'Version',
    unread: 'unread',
    markAllRead: 'Mark all read',
    uploadImage: 'Upload',
    uploadLaterNotice: 'The upload was not started. You can continue using the chat. If you want to upload files later, you can set a password any time.',
    uploadPwBody: 'To upload files you need a full chat account with your own password. Set a password now to continue the upload.',
    uploadPwTitle: 'Upload files',
    verifiedBody: 'This chat has been saved and is now linked to your chat account. You can reopen it later with an email code.',
    verifiedTitle: 'Your email address has been confirmed.',
    welcomeMessage: 'Welcome. How can we help you?',
    guestRateLimited: 'Many chats were just started from this connection. Please try again in a few minutes.',
    guestUnavailable: 'The chat is not available right now. Please try again later.',
    writeMessage: 'Write a message...',
    zipCode: 'Zip code',
  }
}

function detectLanguage() {
  const lang = navigator.language || navigator.userLanguage || 'de'
  const short = lang.substring(0, 2).toLowerCase()
  return messages[short] ? short : 'de'
}

const currentLocale = ref(detectLanguage())

export function useI18n() {
  function t(key) {
    return messages[currentLocale.value]?.[key]
        || messages.de[key]
        || key
  }

  return { t, locale: currentLocale }
}
